import {
    Box,
    Typography,
    Button
} from "@mui/material";

import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";

import BackpackOutlinedIcon from "@mui/icons-material/BackpackOutlined";


// URL de tu backend
const backendURL = `${process.env.REACT_APP_BACKEND_URL}/storage/`;


export const CardCurso = ({ curso }) => {

    // =========================================================
    // COLORES POR CATEGORÍA
    // =========================================================

    const coloresCategoria = {

        1: {
            principal: "#8f1515",
            fondo: "#8f1515",
        },

        2: {
            principal: "#243b64",
            fondo: "#243b64",
        },

        3: {
            principal: "#15999c",
            fondo: "#15999c",
        },

    };


    // =========================================================
    // COLOR DE LA CATEGORÍA
    // =========================================================

    const color =
        coloresCategoria[curso.categoria_id] ||
        {
            principal: "#243b64",
            fondo: "#243b64",
        };


    // =========================================================
    // URL DEL PDF
    // =========================================================

    const urlPDF = curso.archivo
        ? `${backendURL}${curso.archivo}`
        : null;


    return (

        <Box
            sx={{
                width: 150,

                height: 170,

                background: "#fff",

                borderRadius: "16px",

                display: "flex",

                flexDirection: "column",

                alignItems: "center",

                justifyContent: "space-between",

                p: 1.5,

                boxShadow:
                    "0 6px 20px rgba(0,0,0,.08)",

                transition: "all .35s ease",

                "&:hover": {
                    transform: "translateY(-8px)",

                    boxShadow:
                        "0 15px 30px rgba(0,0,0,.15)",
                },
            }}
        >

            {/* ================================================= */}
            {/* ICONO */}
            {/* ================================================= */}

            <Box
                sx={{
                    width: 58,

                    height: 58,

                    borderRadius: "50%",

                    background: color.fondo,

                    display: "flex",

                    alignItems: "center",

                    justifyContent: "center",

                    color: "#fff",
                }}
            >

                <BackpackOutlinedIcon
                    sx={{
                        fontSize: 34,
                    }}
                />

            </Box>


            {/* ================================================= */}
            {/* TEXTO */}
            {/* ================================================= */}

            <Box
                sx={{
                    textAlign: "center",
                }}
            >

                <Typography
                    sx={{
                        fontWeight: 700,

                        fontSize: "15px",

                        color: color.principal,
                    }}
                >
                    {curso.nombre}
                </Typography>

            </Box>


            {/* ================================================= */}
            {/* BOTÓN */}
            {/* ================================================= */}

            <Button
                href={urlPDF || undefined}
                target="_blank"
                rel="noopener noreferrer"

                disabled={!urlPDF}

                endIcon={
                    <ArrowForwardIosRoundedIcon
                        sx={{
                            fontSize:
                                "12px !important",
                        }}
                    />
                }

                sx={{
                    height: 30,

                    px: 2,

                    borderRadius: "20px",

                    textTransform: "none",

                    fontSize: "11px",

                    fontWeight: 600,

                    color: color.principal,

                    border:
                        `1px solid ${color.principal}`,

                    "&:hover": {
                        background:
                            color.principal,

                        color: "#fff",
                    },
                }}
            >
                Ver horario
            </Button>

        </Box>
    );
};